import { getPrimedCtx } from "./audioUnlock";

// Standard emergency alert audio: a SAME-style AFSK digital burst (3 bursts, like a real header)
// followed by the 1050 Hz NWR warning-alarm tone. Synthesized through the primed AudioContext so
// it fires instantly when the emergency widget appears — no user gesture needed.
function sameBurst(ctx, seconds) {
  const sr = ctx.sampleRate;
  const len = Math.floor(sr * seconds);
  const buf = ctx.createBuffer(1, len, sr);
  const ch = buf.getChannelData(0);
  const MARK = 2083.3, SPACE = 1562.5, baud = 520.83;
  const bitLen = Math.max(1, Math.floor(sr / baud));
  let i = 0, phase = 0;
  while (i < len) {
    const freq = Math.random() > 0.5 ? MARK : SPACE;   // AFSK-style alternating mark/space
    const inc = (2 * Math.PI * freq) / sr;
    for (let b = 0; b < bitLen && i < len; b++, i++) { ch[i] = Math.sin(phase) * 0.9; phase += inc; }
  }
  return buf;
}

let lastPlay = 0;

export function playEmergencyTones() {
  const ctx = getPrimedCtx();
  if (!ctx) return false;
  const nowMs = Date.now();
  if (nowMs - lastPlay < 4000) return true;   // guard against double-fire
  lastPlay = nowMs;
  try {
    const start = ctx.currentTime + 0.06;
    const master = ctx.createGain();
    master.gain.value = 0.22;
    master.connect(ctx.destination);

    let t = start;
    for (let k = 0; k < 3; k++) {
      const src = ctx.createBufferSource();
      src.buffer = sameBurst(ctx, 0.85);
      const g = ctx.createGain();
      g.gain.value = 0.85;
      src.connect(g); g.connect(master);
      src.start(t);
      t += 0.85 + 0.08;
    }

    t += 0.2;
    const osc = ctx.createOscillator();
    osc.type = "sine";
    osc.frequency.value = 1050;   // the 1050 Hz warning alarm tone
    const og = ctx.createGain();
    const end = t + 8;
    og.gain.setValueAtTime(0.0001, t);
    og.gain.linearRampToValueAtTime(0.85, t + 0.05);
    og.gain.setValueAtTime(0.85, end - 0.12);
    og.gain.linearRampToValueAtTime(0.0001, end);
    osc.connect(og); og.connect(master);
    osc.start(t); osc.stop(end + 0.05);
    return true;
  } catch {
    return false;
  }
}
